import React from 'react';

const BS_Pagination = () => {
    return (
        <div>
            <h1>BS_Pagination Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Pagination;
